module.exports = __webpack_public_path__ + "img/release.5b6b433c.png";